/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  DepositManager,
  DepositManagerInterface,
} from "../DepositManager";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ITokenRegistry",
        name: "_tokenRegistry",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "maxSubtreeDepth",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "pubkeyID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "l2Amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "subtreeID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "depositID",
        type: "uint256",
      },
    ],
    name: "DepositQueued",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "subtreeID",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "subtreeRoot",
        type: "bytes32",
      },
    ],
    name: "DepositSubTreeReady",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "babyTrees",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "babyTreesLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "back",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "depositCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "pubkeyID",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "l1Amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tokenID",
        type: "uint256",
      },
    ],
    name: "depositFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "dequeueToSubmit",
    outputs: [
      {
        internalType: "uint256",
        name: "subtreeID",
        type: "uint256",
      },
      {
        internalType: "bytes32",
        name: "subtreeRoot",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "front",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paramMaxSubtreeDepth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paramMaxSubtreeSize",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "queue",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "subtreeRoot",
        type: "bytes32",
      },
    ],
    name: "reenqueue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rollup",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rollup",
        type: "address",
      },
    ],
    name: "setRollupAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenRegistry",
    outputs: [
      {
        internalType: "contract ITokenRegistry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class DepositManager__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _tokenRegistry: string,
    _vault: string,
    maxSubtreeDepth: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DepositManager> {
    return super.deploy(
      _tokenRegistry,
      _vault,
      maxSubtreeDepth,
      overrides || {}
    ) as Promise<DepositManager>;
  }
  getDeployTransaction(
    _tokenRegistry: string,
    _vault: string,
    maxSubtreeDepth: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _tokenRegistry,
      _vault,
      maxSubtreeDepth,
      overrides || {}
    );
  }
  attach(address: string): DepositManager {
    return super.attach(address) as DepositManager;
  }
  connect(signer: Signer): DepositManager__factory {
    return super.connect(signer) as DepositManager__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DepositManagerInterface {
    return new utils.Interface(_abi) as DepositManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DepositManager {
    return new Contract(address, _abi, signerOrProvider) as DepositManager;
  }
}
